module.exports = __webpack_public_path__ + "assets/f2068bf6fe34f49d760d6665a26d9be0.mp3";